import React from 'react';
import {Card, CardHeader, CardContent, Typography} from '@mui/material';
import UpcomingAppointmentsTable from './UpcomingAppointmentsTable';
import AttentionModal from "../../components/common/AttentionModal";
import {useMutation} from '@apollo/client';
import {SUBMIT_ATTENTION, GET_UPCOMING_APPOINTMENTS} from '../../gql/dashboard.gql';
import {useTranslation} from 'react-i18next';
import AppSnackbar from '../../common/AppSnackbar';

export default function DashboardUpcomingAppointmentsCard({items, loading, error, limit = 10}) {
    const {t} = useTranslation();
    const [modalOpen, setModalOpen] = React.useState(false);
    const [currentAnimal, setCurrentAnimal] = React.useState({id: null, name: ''});
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [severity, setSeverity] = React.useState('success');
    const [addAttention, {loading: submitting}] = useMutation(SUBMIT_ATTENTION);

    const onRowClick = (appointment) => {
        const animal = appointment?.animal;
        if (!animal) return;
        setCurrentAnimal(animal);
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };

    const handleSubmitAttention = (subject) => {
        if (!currentAnimal?.uuid) return;
        addAttention({
            variables: {
                animalUuid: currentAnimal.uuid,
                subject,
            },
            refetchQueries: [
                {query: GET_UPCOMING_APPOINTMENTS, variables: {limit}},
            ],
            awaitRefetchQueries: true,
        }).then(() => {
            setSnackbarMessage(t('attention.save.success'));
            setSeverity('success');
            setOpenSnackbar(true);
        }).catch(() => {
            setSnackbarMessage(t('attention.save.error'));
            setSeverity('error');
            setOpenSnackbar(true);
        }).finally(() => handleClose());
    };

    return (
        <Card variant="none" sx={{p: 2, m: 2, height: '100%'}}>
            <CardHeader title={<Typography color="secondary" variant="h5" align="center">Aankomende afspraken</Typography>}
                        subheader={<Typography align="center" variant="caption">Volgende {items.length} afspraken</Typography>}/>
            <CardContent>
                {loading && (
                    <Typography color="text.secondary">Loading...</Typography>
                )}
                {!loading && error && (
                    <Typography color="error">Error loading appointments</Typography>
                )}
                {!loading && !error && (!items || items.length === 0) && (
                    <Typography color="primary">Geen aankomende afspraken</Typography>
                )}
                {!loading && !error && items && items.length > 0 && (
                    <UpcomingAppointmentsTable items={items} onRowClick={onRowClick}/>
                )}

                <AttentionModal
                    open={modalOpen}
                    animalName={currentAnimal?.name}
                    onClose={handleClose}
                    onSubmit={handleSubmitAttention}
                    submitting={submitting}
                />
            </CardContent>
            <AppSnackbar openSnackbar={openSnackbar}
                         snackbarMessage={snackbarMessage}
                         setOpenSnackbar={setOpenSnackbar}
                         severity={severity}/>
        </Card>
    );
}
